import { React } from '../utils/thirdpartyComponents';
import CWRadio from './CWRadio';
import CWSwitch from './CWSwitch';
import { DISCOUNT_MAX_LENGTH } from '../utils/constants';
import { FleetPaymentMode } from '../utils/enums';
import { sanitizeDiscountPercentInput } from '../utils/locationFleetSettings';
import './LocationFleetSettings.scss';

interface LocationFleetSettingsProps {
  enableFleetDiscount: boolean;
  fleetDiscount: string;
  fleetPaymentMode: number | null;
  errors: Record<string, string>;
  onToggle: (enabled: boolean) => void;
  onDiscountChange: (value: string) => void;
  onPaymentModeChange: (mode: number) => void;
  refs?: React.MutableRefObject<{ [key: string]: HTMLInputElement | HTMLTextAreaElement | null }>;
}

const LocationFleetSettings: React.FC<LocationFleetSettingsProps> = ({
  enableFleetDiscount,
  fleetDiscount,
  fleetPaymentMode,
  errors,
  onToggle,
  onDiscountChange,
  onPaymentModeChange,
  refs,
}) => {
  const handleDiscountChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const nextValue = sanitizeDiscountPercentInput(e.target.value);
    if (nextValue === null) {
      return;
    }
    onDiscountChange(nextValue);
  };

  return (
    <div className="car-info-sec fleet-settings-sec d-flex flex-column align-items-start mb-4">
      <div className="info-switch d-flex align-items-center gap-3">
        <h5 className="f-bold m-0">Allow Fleet Discount</h5>
        <CWSwitch
          id="enableFleetDiscount"
          name="enableFleetDiscount"
          checked={enableFleetDiscount}
          onChange={() => onToggle(!enableFleetDiscount)}
        />
      </div>
      {enableFleetDiscount ? (
        <>
          <div className="fleet-discount-field">
            <label htmlFor="fleetDiscount">Provide Discount</label>
            <div className="fleet-discount-input-wrap">
              <input
                id="fleetDiscount"
                name="fleetDiscount"
                type="text"
                inputMode="decimal"
                className={errors.fleetDiscount ? 'form-control error' : fleetDiscount !== '' ? 'form-control active' : 'form-control'}
                value={fleetDiscount}
                maxLength={DISCOUNT_MAX_LENGTH}
                onChange={handleDiscountChange}
                ref={(el) => {
                  if (refs) {
                    refs.current.fleetDiscount = el;
                  }
                }}
              />
              <span className="fleet-discount-suffix">%</span>
            </div>
            {errors.fleetDiscount ? <span className="error-msg">{errors.fleetDiscount}</span> : null}
          </div>
          <div className="adderss-sec w-100">
            <h5 className="f-bold">Payment Method</h5>
            <div className="radio-field-group d-flex">
              <CWRadio
                id="fleetPaymentCreditCard"
                name="fleetPaymentMode"
                label="Credit Card"
                checked={fleetPaymentMode === FleetPaymentMode.CreditCard}
                onChange={() => onPaymentModeChange(FleetPaymentMode.CreditCard)}
              />
              <CWRadio
                id="fleetPaymentCheque"
                name="fleetPaymentMode"
                label="Cheque"
                checked={fleetPaymentMode === FleetPaymentMode.ByCheck}
                onChange={() => onPaymentModeChange(FleetPaymentMode.ByCheck)}
              />
            </div>
            {errors.fleetPaymentMode ? (
              <span className="error-msg">{errors.fleetPaymentMode}</span>
            ) : null}
          </div>
        </>
      ) : null}
    </div>
  );
};

export default LocationFleetSettings;
